// extracted by mini-css-extract-plugin
module.exports = {"activity":"ActivityView_activity___U5yC","avatarIconWrap":"ActivityView_avatarIconWrap__55CXA","date":"ActivityView_date__HZRU2","username":"ActivityView_username__f6wKU"};